import React, { useContext } from "react";

import ShiftSurveyPharmaOwner from "./ShiftSurveyPharmaOwner";
import ShiftSurvey from "./ShiftSurvey";

import { IndustryModeEnum } from "../../api/constants";
import { RBContext } from "../../components/RBContext";
import { AuthService } from "../../api/AuthService";
import { roleNameEnum } from "../../util/Common";

export const ShiftSurveyPage: React.FC = () => {
  const { industryMode } = useContext(RBContext);
  const roleName = AuthService.getRoleName();

  if (
    industryMode === IndustryModeEnum.Pharmaceutical &&
    (roleName === roleNameEnum.owner ||
      roleName === roleNameEnum.regionalmanager)
  ) {
    return <ShiftSurveyPharmaOwner />;
  }

  return <ShiftSurvey />;
};

export default ShiftSurveyPage;
